import React, { useRef, useState } from "react";
import {
  Box,
  Button,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import "react-datepicker/dist/react-datepicker.css";
import SearchIcon from "@mui/icons-material/Search";
import { useEffect } from "react";
import { getCategorySalesCustomers } from "./reportsApi";
import ReportCard from "./reportCard";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import GstReports from "./gstReport/gstReport";
import DiscountinuedItem from "./discountedItems/discountedItems";
import TotalCounterSellReport from "./totalCounterSaleReport.jsx/totalCounterSellReport";
import ItemCounterSellReport from "./itemWiseSaleSummary.jsx/itemCounterSellReport";
import SearchModal from "./searchModal";
import { payloadDateFormat } from "../../utils/commonUtils";
import { useDispatch, useSelector } from "react-redux";
import { setServiceViceSearch } from "../../app/store/reducer";
import RateChangeItemHistory from "./rateChangeHistory/rateChangeHistory";
import CashCounterSale from "./cashCounterSale/cashCounterSale";
import EmployeePaymentRole from "./employeePaymentReport/employeePaymentRole";
import EmployeeAdvanceReport from "./employeeAdvanceReport/employeeAdvanceReport";
import RawMaterialReport from "./RawMaterialReport/RawMaterialReport";
import ListOfItemSerivces from "./ListOfItemSerivces/ListOfItemSerivces";
import PurchaseReportData from "./purchaseReport/purchaseReport";
import ExpenceReport from "./expensereport/expensereport";
import { InventoryReport } from "./InntryReport/InntryReport";
import EmployeeDetailReport from "./employeeDetailReport/employeeDetailReport";
import EmploDeReport from "./employeeDetailReport/employeeDetailReport";
import EmpPayRollReport from "./employeePayroll/employeePayroll";
import { CustomerDetailReport } from "./customerDetailReport";
import CustomerInfo from "../counterInformation/CustomerInfo";
import DynamicBreadcrumbs from "../../common/Breadcrumb";
import CounterSaleOfSelectedItem from "./counterSaleOfSelectedItem/counterSaleOfSelectedItem";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import AppoinmentReport from "./appoinmentReport/appoimentReportapge";
import SalesReport from "./itemCategory";
import ItemWiseCategoryCounter from "./itemWiseSaleSummary.jsx";
import GstReportText from "./gstReport/index.jsx";
import RawMaterialReportT from "./RawMaterialReport/index.jsx";
import PurchaseReportT from "./purchaseReport/index.jsx";
import InventoryT from "../stocks/index.jsx";
import { ReportTabT } from "../../common/reportTab.jsx";

const Reports = () => {
  const [filters, setFilters] = useState([
    {
      name: "Discontinued items/Services list ",
      value: "DiscountinueditemsServiceslist",
    },
    { name: "Gst Report", value: "GstReport" },

    {
      name: "Item Category Wise Daily Counter Sales",
      value: "ItemCatogery",
    },
    {
      name: "Total Counter Sale Report",
      value: "Totalcountersalereport"
    },
    {
      name: "Item Wise Counter Sale Report",
      value: "ItemWiseCounterSaleReport",
    },
    {
      name: " Raw Material Report ",
      value: "RawMaterialReport",
    },
    {
      name: "Counter Sale Of Selected Item",
      value: "CounterSaleOfSelectedItem",
    }, {
      name: "List Of Items/ Services",
      value: "ListOfItemSerivces",
    },
    {
      name: "Purchase Report",
      value: "PurchaseReportData",
    },
    {
      name: "Expense Report",
      value: "ExpenceReport",
    },
    {
      name: "Inventory Report",
      value: "InventoryReport",
    },
  ]);

  const [filters_t, setFilters_t] = useState([
    {
      name: "Employee Payroll Report",
      value: "EmployeePaymentRole",
    },
    {
      name: "Employee Advance Payment Report",
      value: "EmployeeAdvanceReport",
    },
    { name: "Employee Details Report", value: "EmploDeReport" },
  ]);
  const [filters_th, setFilters_th] = useState([
    {
      name: "Customer History Report ",
      value: "CustomerHistoryReport",
    },
    { name: "Customer Information Report", value: "CustomerDetailReport" },
  ]);

  const [filterBy, setFilterBy] = useState("DiscountinueditemsServiceslist");
  const [open2, setOpen2] = useState(false);

  function addLeadingZero(value) {
    return value < 10 ? "0" + value : value;
  }

  const displayDateFormat = () => {
    var currentDate = new Date();
    let dateContainer = String(currentDate).split(" ");

    var year = dateContainer[2];
    var month = dateContainer[1];

    var day = dateContainer[3];

    var formattedDate =
      year + "-" + addLeadingZero(month) + "-" + addLeadingZero(day);

    return formattedDate;
  };
  const [CategorySale, setCategorySale] = useState({
    totalSales: "",
    total: [],
  });
  const [billFilter, setBillFilter] = useState("cash");

  const [date, setDate] = useState(displayDateFormat);

  const [startDate, setStartDate] = useState(new Date());
  const [search, setSearch] = useState("");
  const datePickerRef = useRef();

  const openDatePicker = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setOpen(true);
    }
  };

  const serviceViceSearch = useSelector(
    (state) => state.reducer.serviceViceSearch
  );

  const getData = async (param) => {
    await getCategorySalesCustomers(param)
      .then((res) => {
        console.log("Category Customer ", res);
        setCategorySale({
          ...CategorySale,
          total: res?.data?.data?.categoryWiseCounterSale,
          totalSales: res?.data?.data?.totalSales,
        });
      })
      .catch((err) => {
        console.log("err ", err);
      });
  };

  const datePickerOnChange = (date) => {
    const dateStr = date.toLocaleDateString("en-GB", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
    const dateStr2 = date.toLocaleDateString("en-GB", {
      year: "numeric",
      month: "long",
      day: "2-digit",
    });
    const [month, day, year] = dateStr.split("/");
    const formattedDate = `${year}-${day.padStart(2, "0")}-${month.padStart(
      2,
      "0"
    )}`;
    let dateContainer = String(dateStr2).split(" ");
    var year2 = dateContainer[2];
    var month2 = dateContainer[1];
    var day2 = dateContainer[0];
    var formattedDate2 = day2 + "-" + month2 + "-" + year2;
    console.log("formattedDate2 ", formattedDate2);
    console.log("date", date);
    getData({
      date: formattedDate,
      // page:1,
      // pageSize:4
    });
    setDate(formattedDate2);
    setStartDate(date);
  };

  const businessChooseTab = useSelector(
    (state) => state.reducer.businessChooseTab
  );

  useEffect(() => {
    // setFilterBy(businessChooseTab?.value)
    console.log("businessChooseTab?.value ", businessChooseTab?.value);
    setFilterBy(businessChooseTab?.value);
  }, [businessChooseTab]);

  const dispatch = useDispatch();

  // useEffect(() => {
  //   console.log("datE ", date);
  //   getData({
  //     date: payloadDateFormat(),
  //   });
  // }, []);

  const primaryColor = () => {
    return (theme) => theme.palette.primary.main;
  };

  const [dateValue, setDateValue] = useState(null);
  return (
    <>
      {/* <DynamicBreadcrumbs /> */}
      <Box sx={{}}>
        <Grid
          container
          sx={{
            pb: "20px",
            overflowY: "auto",
            minHeight: {
              xs: "100vh",
              sm: "calc(100vh - 60px)",
            },
          }}
        >
          <Grid item xs={6}>
            <Box></Box>
          </Grid>
          <Grid item xs={12}>
            <ReportTabT filterBy={filterBy ?? "BusiReport"} />
          </Grid>
          <Grid item xs={12}>
            {filterBy === "ItemWiseCounterSaleReport" && (
              <ItemWiseCategoryCounter />
            )}
            {filterBy === "Totalcountersalereport" && (
              <TotalCounterSellReport />
            )}
            {filterBy === "DiscountinueditemsServiceslist" && (
              <DiscountinuedItem />
            )}
            {filterBy === "GstReport" && <GstReportText />}
            {filterBy === "RateChangeItemHistory" && <RateChangeItemHistory />}
            {filterBy === "CashCounterSale" && <CashCounterSale />}
            {filterBy === "EmployeePaymentRole" && <EmployeePaymentRole />}
            {filterBy === "EmployeeAdvanceReport" && <EmployeeAdvanceReport />}
            {filterBy === "RawMaterialReport" && <RawMaterialReportT />}
            {filterBy === "CounterSaleOfSelectedItem" && (
              <CounterSaleOfSelectedItem />
            )}

            {filterBy === "ItemCatogery" && (
              <SalesReport />
            )}
            {filterBy === "PurchaseReportData" && <PurchaseReportT />}
            {filterBy === "ListOfItemSerivces" && <ListOfItemSerivces />}
            {filterBy === "ExpenceReport" && <ExpenceReport />}
            {filterBy === "InventoryReport" && <InventoryT />}
            {filterBy === "EmploDeReport" && <EmploDeReport />}

            {filterBy === "AppoinmentReport" && <AppoinmentReport />}
            {filterBy === "CustomerDetailReport" && <CustomerDetailReport />}

            {filterBy === "CustomerHistoryReport" &&
              <CustomerInfo
                gridSize={{
                  sm: 6,
                }}
              />
            }

            {filterBy === "EmployeePayroll" && <EmpPayRollReport />}
          </Grid>
          <SearchModal
            open={open2}
            setOpen={setOpen2}
            setFilterBy={setFilterBy}
          />
        </Grid>
      </Box>
    </>
  );
};

export default Reports;
